import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ClientEmbeddedReporting.scss';export default {
  "ClientEmbeddedReporting": "_ClientEmbeddedReporting_u4n95_1",
  "header": "_header_u4n95_1",
  "addButton": "_addButton_u4n95_7",
  "AddOrEditModal": "_AddOrEditModal_u4n95_11",
  "select": "_select_u4n95_11",
  "input": "_input_u4n95_14",
  "inputLabel": "_inputLabel_u4n95_18"
};